<div class="d-flex flex-column justify-content-center align-items-center" style="width: 100vw; height: 100vh" id="bg2">
  <img loading="eager" src="./../../../assets/logos/sscwhite.png" class="img-fluid" alt="Responsive image"
    style="height: 120px; width: 300px; object-fit: contain;" />
  <div class="spinner-border text-white mt-4" role="status">
    <!-- <span class="sr-only">Loading...</span> -->
  </div>
</div>